/**
 * Listing Header DOM Component
 *
 * Creates the sticky header element for the listing sheet, containing the title.
 *
 * @module nativeInteractiveSiteMap/components/listingHeader.dom
 */

import fastdom from 'fastdom';
import createListingTitle from './listingTitle.dom';

export default function createListingHeader() {
  const headerElement = document.createElement('div');

  const gridClasses = [
    'nhs-c-native-interactive-site-map__listing-header',
    'nhs-mq-native-interactive-site-map__listing-header-medium',
  ];

  headerElement.className = gridClasses.join(' ');
  headerElement.setAttribute('data-listing-header', '');

  const titleComponent = createListingTitle();
  headerElement.appendChild(titleComponent.getElement());

  return {
    getElement() {
      return headerElement;
    },
    setText(text) {
      titleComponent.setText(text);
    },
    remove() {
      fastdom.mutate(() => {
      headerElement.remove();
      });
    },
  };
}
